import React, { useEffect, useState } from "react";
import "../sections.css";
import { getTarjetasInicio } from "../../../../config/services/strapi/home";
import TextSkeleton from "../../../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../../../components/Skeleton/ImageSkeleton";

export default function NuestraHistoria() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const tarjetas = await getTarjetasInicio();
        // Buscamos la tarjeta dinámicamente por título
        const tarjetaHistoria = tarjetas.find(
          (t: any) => (t.titulo || t.Titulo || "").toUpperCase() === "NUESTRA HISTORIA"
        );
        setData(tarjetaHistoria);
      } catch (error) {
        console.error("Error cargando Nuestra Historia:", error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  const imageUrl = data?.portada?.url || null;
  const title = data?.Titulo || data?.titulo || "NUESTRA HISTORIA";

  return (
    <section className="section nuestra-historia-hero">
      <div className="section-inner">
        {/* Columna de Texto */}
        <div className="col-text">
          {loading ? (
            <TextSkeleton className="relative z-[99999] pointer-events-none" />
          ) : (
            <>
              <h1>
                {title.split(" ").map((word: string, i: number) => (
                  <React.Fragment key={`${word}-${i}`}>
                    {word} {i === 0 && <br />}
                  </React.Fragment>
                ))}
              </h1>
              <a href="/nuestra-historia" className="full-link" aria-label="Ir a Nuestra Historia" />
            </>
          )}
        </div>

        {/* Columna de Media */}
        <div className="col-media">
          {loading ? (
            <ImageSkeleton className="h-full relative z-[99999999] pointer-events-none" />
          ) : (
            <div
              className="media-cover"
              style={{
                backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
              }}
            />
          )}
          <a href="/nuestra-historia" className="full-link" aria-label="Ir a Nuestra Historia" />
        </div>
      </div>
    </section>
  );
}